import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { Feature } from '@rma/dashboard/team/public/api-profile-members';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { map, Observable, switchMap } from 'rxjs';
import { UserPermissionsApiService } from '../api/user-permissions-api.service';

@Injectable({ providedIn: 'root' })
export class UserPermissionsContextService {
  private readonly profileCtx = inject(DashboardProfileContextService);
  private readonly userPermissionsApi = inject(UserPermissionsApiService);

  public permissions$: Observable<Feature[]>;

  constructor() {
    this.permissions$ = this.profileCtx.profileIdentifier$.pipe(
      switchMap(({ profileType, profileCode }) => this.userPermissionsApi.getPermissions(profileType, profileCode)),
      rmaShareReplay(),
    );
  }

  public getPermission(featureName: Feature): Observable<Feature | null> {
    return this.permissions$.pipe(
      map((features) => features.find((feature) => feature === featureName) ?? null),
      rmaShareReplay(),
    );
  }

  public hasPermission(featureName: Feature): Observable<boolean> {
    return this.getPermission(featureName).pipe(
      map((feature) => !!feature),
      rmaShareReplay(),
    );
  }
}
